import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container my-4 practice-records" }
const _hoisted_2 = { class: "row g-3 mb-4" }
const _hoisted_3 = { class: "col-6 col-md-3" }
const _hoisted_4 = { class: "stat-card" }
const _hoisted_5 = { class: "stat-value" }
const _hoisted_6 = { class: "col-6 col-md-3" }
const _hoisted_7 = { class: "stat-card" }
const _hoisted_8 = { class: "stat-value" }
const _hoisted_9 = { class: "col-6 col-md-3" }
const _hoisted_10 = { class: "stat-card" }
const _hoisted_11 = { class: "stat-value" }
const _hoisted_12 = { class: "col-6 col-md-3" }
const _hoisted_13 = { class: "stat-card" }
const _hoisted_14 = { class: "stat-value" }
const _hoisted_15 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_16 = { class: "table align-middle records-table" }
const _hoisted_17 = { class: "text-capitalize" }

import { ref, computed, onMounted } from "vue";
import { getHistory, getStatistics } from "@/api/users";
import { useAuth } from "@/composables/useAuth";
import { handleError } from "@/services/errorHandler";
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
import ErrorMessage from "@/components/common/ErrorMessage.vue";
import EmptyState from "@/components/common/EmptyState.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PracticeRecords',
  setup(__props) {

const { isAuthenticated, init } = useAuth();

const loading = ref(false);
const errorMessage = ref("");
const history = ref([]);
const stats = ref({
  total_sessions: 0,
  graded_sessions: 0,
  average_band: null,
  sessions_by_skill: {},
});

const skillCount = computed(
  () => Object.keys(stats.value.sessions_by_skill || {}).length
);

const formatStatus = (s) =>
  ({
    in_progress: "In progress",
    submitted: "Submitted",
    graded: "Graded",
    expired: "Expired",
    abandoned: "Abandoned",
  }[s] || s);

const statusClass = (s) =>
  ({
    in_progress: "bg-secondary",
    submitted: "bg-info text-dark",
    graded: "bg-success",
    expired: "bg-warning text-dark",
    abandoned: "bg-light text-dark",
  }[s] || "bg-secondary");

const formatDate = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString();
};

async function load() {
  await init();
  if (!isAuthenticated.value) return;

  loading.value = true;
  errorMessage.value = "";
  try {
    const [historyData, statsData] = await Promise.all([
      getHistory({ page: 1, size: 50 }),
      getStatistics(),
    ]);
    history.value = historyData.items;
    stats.value = statsData;
  } catch (e) {
    errorMessage.value = handleError(e, "PracticeRecords.load");
  } finally {
    loading.value = false;
  }
}

onMounted(load);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "page-title mb-4" }, "Practice Records", -1)),
    (loading.value)
      ? (_openBlock(), _createBlock(LoadingSpinner, {
          key: 0,
          message: "Loading your practice records..."
        }))
      : (errorMessage.value)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 1,
            title: "Could not load your records",
            message: errorMessage.value,
            onRetry: load
          }, null, 8, ["message"]))
        : (!_unref(isAuthenticated))
          ? (_openBlock(), _createBlock(EmptyState, {
              key: 2,
              icon: "bi-person-lock",
              title: "Sign in to view your records",
              message: "Your practice history, scores and statistics appear here once you are signed in."
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(stats.value.total_sessions), 1),
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "stat-label" }, "Total attempts", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(stats.value.graded_sessions), 1),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "stat-label" }, "Graded", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(stats.value.average_band ?? "—"), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "stat-label" }, "Average band", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(skillCount.value), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "stat-label" }, "Skills practised", -1))
                  ])
                ])
              ]),
              (!history.value.length)
                ? (_openBlock(), _createBlock(EmptyState, {
                    key: 0,
                    icon: "bi-clipboard-x",
                    title: "No attempts yet",
                    message: "Start a mock exam to begin building your practice history."
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("table", _hoisted_16, [
                      _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Skill"),
                          _createElementVNode("th", null, "Status"),
                          _createElementVNode("th", null, "Band"),
                          _createElementVNode("th", null, "Started"),
                          _createElementVNode("th", null, "Submitted")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(history.value, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: row.id
                          }, [
                            _createElementVNode("td", _hoisted_17, _toDisplayString(row.skill), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge", statusClass(row.status)])
                              }, _toDisplayString(formatStatus(row.status)), 3)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(row.score ? row.score.band_score : "—"), 1),
                            _createElementVNode("td", null, _toDisplayString(formatDate(row.started_at)), 1),
                            _createElementVNode("td", null, _toDisplayString(formatDate(row.submitted_at)), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
            ], 64))
  ]))
}
}

})